var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('header-area',{ref:"headerAreaRef"}),_c('router-view'),_c('common-loading'),_c('logistics-notification'),_c('footer-area')],1)}
var staticRenderFns = []

export { render, staticRenderFns }